<main id="foundation_main">
  <!-- <app-navbar></app-navbar> -->

  <div id="container">
    <h1 id="title">Edital</h1>
    <div id="content">
      <div id="pink-box"></div>

      <div id="pink-line"></div>

      <div id="blue-box"><strong>PUC, MOSTRA TUA ARTE</strong></div>

      <div id="beige-box">
        <!-- <p id="title-text-pink" class="upper"><strong>Chamada aberta: Seletiva para artistas e criadores da
            PUC-RIO</strong></p> -->
            <p id="title-text-pink" class="upper"><strong>Resultado do Edital</strong></p>

        <!-- <p id="sub-title-text-blue">
          No ano de 2023 estamos comemorando 40 anos de atividades da Fundação Padre Leonel Franca (FPLF). Ao longo de
          quatro décadas, um dos principais eixos que nortearam a atuação da FPLF tem sido o apoio às atividades
          socioculturais que propagam os valores éticos, humanistas e solidários que, historicamente, balizaram o
          notório trabalho de ensino e pesquisa da Pontifícia Universidade Católica (PUC-Rio).
        </p>
        <p id="sub-title-text-blue">
          É dentro dessa perspectiva que a FPLF convida todos os alunos da PUC a se
          inscreverem para participar da mostra cultural “PUC, mostra sua arte", que acontecerá na última semana do
          calendário de comemorações dos 40 anos de existência da Fundação. A partir dessas inscrições, serão
          selecionados trabalhos para fazerem parte desse importante momento de celebração e alegria.
        </p> -->
        
        
        <p id="sub-title-text-pink">Alberto Pereira</p>
        <p id="sub-title-text-blue">Aluno do Departamento de Comunicação Social</p>
        <p id="sub-title-text-blue">Intervenção Lambe-lambe (Artes Plásticas)</p>
        <br />
        <p id="sub-title-text-pink">Maria Clara Miranda Pieper</p>
        <p id="sub-title-text-blue">Aluna do Departamento de Comunicação Social</p>
        <p id="sub-title-text-blue">O SOL QU’EU NUNCA VI (Teatro)</p>
        <br />
        <p id="sub-title-text-pink">Marcos Paulo Mendes de Amorim Júnior</p>
        <p id="sub-title-text-blue">Aluno do Departamento de Psicología</p>
        <p id="sub-title-text-blue">"UM JESUÍTA PARA JESUS" - PE. LEONEL FRANCA (Música)</p>      
        <br /> 
        <br />
        <!-- <p id="title-text-pink"><strong>Regulamento:</strong></p>

        <p id="sub-title-text-blue">
          a) Podem se inscrever na presente Chamada artistas e criadores que sejam alunos de graduação, mestrado e
          doutorado da PUC-Rio
        </p>
        <p id="sub-title-text-blue">
          b) Serão aceitas expressões artísticas de todas linguagens e formatos, e inclusive multilinguagens, desde que
          estejam em sintonia com os valores e pilares que norteiam as ações da Fundação Padre Leonel Franca.
        </p>
        <p id="sub-title-text-blue">
          c) O processo de inscrição será feito integralmente de forma on-line através do
          <a class="href_color" href="https://forms.gle/T75woQWJxKnsw4g99">formulário</a> no qual constam as
          instruções específicas para inscrição e as orientações para o envio dos conteúdos que serão avaliados pela
          banca de seleção dos trabalhos.
        </p>
        <p id="sub-title-text-blue">
          d) As inscrições estarão abertas do dia 16/06/2023 até o dia <span class="href_color">25/08/2023 às 23:59</span>.
          Será instituída uma banca para seleção dos trabalhos artísticos composta por professores da PUC-Rio com
          notório saber na área de arte/cultura.
        </p>
        <p id="sub-title-text-blue">
          f) Serão selecionados até 3 (três) trabalhos, dentre os inscritos, e estes receberão, além do suporte técnico
          para a realização de suas expressões artísticas na semana da mostra, um certificado de participação e o apoio
          financeiro de R$ 4.000,00 (quatro mil) reais.
        </p>
        <p id="sub-title-text-blue">
          g) A mostra cultural “PUC, mostra sua arte” acontecerá em data a ser combinada.
        </p> -->
        <p id="sub-title-text-blue" class="center">
          Rio de Janeiro, 18 de setembro de 2023
        </p>
      </div>
    </div>
  </div>

  <!-- <app-footer></app-footer> -->
</main>